"use client";

import Link from "next/link";
import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";

export default function PromoBanner() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const timeoutRef = useRef(null);

  // Currency from Redux — same pattern as SimilarProducts
  const selectedCurrency = useSelector((state) => state.currency.selectedCurrency);
  const currencySymbol = selectedCurrency?.symbol || "₹";
  const conversionRate = selectedCurrency?.conversion_rate || 1;
  const isINR = selectedCurrency?.name?.toLowerCase() === "inr" || selectedCurrency?.code?.toLowerCase() === "inr";
  const isUSD  = selectedCurrency?.name?.toLowerCase() === "usd" || selectedCurrency?.code?.toLowerCase() === "usd";
const freeShippingINR = 2500;
const freeShippingUSD = 500;

// conversionRate is "how many INR = 1 unit of selected currency"
// So USD amount in selected currency = (500 USD * 90.5 INR/USD) / conversionRate
const freeShippingThreshold = isINR
  ? freeShippingINR
  : isUSD
  ? freeShippingUSD
  : parseFloat((freeShippingUSD * 90.5 / conversionRate).toFixed(0));

const formattedThreshold = freeShippingThreshold.toLocaleString("en-IN", {
  maximumFractionDigits: 0,
});

const displayThreshold = isINR
  ? `Rs ${formattedThreshold}`
  : `${currencySymbol}${formattedThreshold}`;
  const messages = [
    { 
      text: "Discover Handcrafted Jewelry!", 
      link: "/shop", 
      linkText: "Shop Now" 
    },
    { 
      text: `Free Shipping Over ${displayThreshold}!`, 
      link: "/shipping", 
      linkText: "Learn More" 
    },
    { 
      text: "New Festive Collection!", 
      link: "/collections/festive", 
      linkText: "Explore" 
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      if (timeoutRef.current) return;

      setIsAnimating(true);

      timeoutRef.current = setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % messages.length);
        setIsAnimating(false);
        timeoutRef.current = null;
      }, 500);
    }, 3500);

    return () => {
      clearInterval(interval);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [messages.length]);

  return (
    <div className="fixed top-0 left-0 right-0 w-full bg-black text-white text-center py-2 sm:py-2.5 text-[10px] sm:text-xs md:text-sm font-medium z-[99] overflow-hidden">
      <div className="relative h-3 sm:h-3 flex items-center justify-center max-w-full px-2">
        {messages.map((message, index) => (
          <div
            key={index}
            className={`absolute inset-0 flex items-center justify-center transition-all duration-500 ease-in-out ${
              index === currentIndex
                ? isAnimating
                  ? "-translate-x-full opacity-0"
                  : "translate-x-0 opacity-100"
                : index === (currentIndex + 1) % messages.length
                ? isAnimating
                  ? "translate-x-0 opacity-100"
                  : "translate-x-full opacity-0"
                : "translate-x-full opacity-0"
            }`}
          >
            <div className="flex items-center justify-center gap-1 sm:gap-2 whitespace-nowrap px-4">
              <span className="truncate max-w-[50vw] sm:max-w-none">
                {message.text}
              </span>
              <span className="flex-shrink-0">|</span>
              <Link 
                href={message.link} 
                className="underline hover:text-gray-300 transition-colors flex-shrink-0"
              >
                {message.linkText}
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}